import { FOLLOW_UP_TYPE_LABELS, followUpListQuerySchema } from '@chukua/common';
import { Select } from 'antd';
import { useCallback } from 'react';
import { useRemoteSearchOptions } from '../../../../../shared/hooks/use-remote-search-options';
import { listFollowUps } from '../../follow-ups/follow-ups.api';
import { formatContactedAt } from '../../follow-ups/policies/follow-up-time';

const PAGE_SIZE = 20;

interface FollowUpSearchSelectProps {
  /** Passed by the form item, so the label points at the field. */
  id?: string;
  customerId: string;
  value?: string;
  onChange?: (followUpId: string) => void;
}

/** The follow-up a promise was made in, newest first: `GET /customers/:id/follow-ups?q=`, opening on the first page. */
export function FollowUpSearchSelect({ id, customerId, value, onChange }: FollowUpSearchSelectProps) {
  const fetchFollowUps = useCallback(
    (q: string | undefined) =>
      listFollowUps(customerId, followUpListQuerySchema.parse({ q, pageSize: PAGE_SIZE })).then((page) =>
        page.items.map((entry) => ({
          value: entry.id,
          label: `${formatContactedAt(entry.contactedAt)} · ${FOLLOW_UP_TYPE_LABELS[entry.type]} · ${entry.outcome}`,
        })),
      ),
    [customerId],
  );
  const { selectProps } = useRemoteSearchOptions(fetchFollowUps);

  return (
    <Select
      {...selectProps}
      id={id}
      value={value}
      onChange={onChange}
      placeholder="Select or search follow-ups"
      notFoundContent={selectProps.loading ? 'Searching…' : 'No follow-ups found. Record one first.'}
    />
  );
}
